var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHourGlass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6665 13.5H10.3332M2.83317 1H11.1665C12.087 1 12.8332 1.74619 12.8332 2.66667V3.56458C12.8332 4.5772 12.3729 5.53491 11.5822 6.16748L9.47991 7.84928C9.0629 8.18288 9.0629 8.81712 9.47991 9.15072L11.5822 10.8325C12.3729 11.4651 12.8332 12.4228 12.8332 13.4354V14.3333C12.8332 15.2538 12.087 16 11.1665 16H2.83317C1.9127 16 1.1665 15.2538 1.1665 14.3333V13.4354C1.1665 12.4228 1.6268 11.4651 2.41752 10.8325L4.51977 9.15072C4.93677 8.81712 4.93677 8.18288 4.51977 7.84928L2.41752 6.16748C1.6268 5.53491 1.1665 4.5772 1.1665 3.56458V2.66667C1.1665 1.74619 1.9127 1 2.83317 1Z",
    stroke: "#FF784B",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourGlass);
export default __webpack_public_path__ + "static/media/hour-glass.261682bef4f4be1d76ed19a56f7de7fe.svg";
export { ForwardRef as ReactComponent };